import moment from 'moment';

export const getFormattedStartRY = (year: number) =>
  moment(`${year}-07-01`).format('YYYY-MM-DD');
